import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'antd/dist/reset.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { ConfigProvider } from 'antd';
import { AppProvider } from 'Context/AppContext';
import MainLayout from 'Layout/MainLayout';
import { ADMIN_ROUTER } from './router';
import { LoginPage } from './Pages';

//page chose role
const ChoseRole = React.lazy(() => import('./Pages/Authen/ChoseRole'));

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'Quicksand',
          colorTextBase: '#000000',
          colorText: '#000000',
          colorTextSecondary: '#000000',
          colorTextTertiary: '#000000',
          colorTextHeading: '#000000',
          colorTextLabel: '#000000',
          colorTextDescription: '#000000',
        },
        components: {
          Table: {
            cellPaddingBlock: 3,
            cellPaddingInline: 8,
            cellFontSize: 13,
            headerColor: '#000000',
          },
          Pagination: {
            itemSize: 26,
            margin: 6,
          },
        },
      }}
    >
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path='/login' element={<LoginPage />} />
            {ADMIN_ROUTER.map((e) => (
              <Route
                key={e.key}
                path={e.path}
                element={
                  <AppProvider>
                    <MainLayout
                      navKey={e.navKey}
                      subNavKey={e.subNavKey}
                      subSubNavKey={(e as any).subSubNavKey}
                      expectRole={e.role}
                    >
                      {e.element}
                    </MainLayout>
                  </AppProvider>
                }
              />
            ))}
            <Route path="/chose-role" element={<ChoseRole />} />
          </Routes>
        </Suspense>
        <ToastContainer
          position='top-center'
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme='light'
        />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
